import { render, staticRenderFns } from "./CUSlideForm.vue?vue&type=template&id=8933702c"
import script from "./CUSlideForm.vue?vue&type=script&lang=js"
export * from "./CUSlideForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports